<template>
  <div class="personnel-recruit">
    <AppBar />
    <div class="page-content">
      <div class="personnel-recruit-canvas">
        <div class="personnel-recruit-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
            <div class="solution-btn" @click="openBealter">预约演示</div>
          </div>
        </div>
      </div>
      <div ref="nav" class="personnel-grow-nav">
        <div ref="navTabs" class="personnel-grow-nav-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['personnel-grow-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div ref="product-value" class="product-value">
        <div class="title">产品价值分析</div>
        <div class="product-value-content">
          <img :src="productValue" alt="" />
        </div>
      </div>
      <div>
        <div ref="architecture" class="architecture">
          <div class="title">系统流程图</div>
          <div class="flow-chart-content">
            <img :src="architecture" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="introduction" class="introduction">
          <div class="title">系统功能介绍</div>
          <div class="introduction-tag-list">
            <div
              v-for="(item, index) in introductionTagList"
              :key="index"
              class="tag-list-item"
              :class="{'tag-list-item-change': introductionIndex == index}"
            >
              <div class="tag-list-text" @click="changeStep(item)">
                {{ item.text }}
              </div>
            </div>
          </div>
          <div class="introduction-content-box">
            <div v-if="introductionList.length != 0" :key="introductionIndex" class="introduction-content">
              <div class="introduction-content-left">
                <div class="content-title">{{ introductionList[introductionIndex].title }}</div>
                <div
                  v-for="(item, index) in introductionList[introductionIndex].content"
                  :key="index"
                  class="content-text-box"
                >
                  <div class="content-text-li"></div>
                  <div class="content-text">{{ item }}</div>
                </div>
              </div>
              <div class="introduction-content-right">
                <img :src="introductionList[introductionIndex].img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div style="background-color: #f7f9fc; padding-top: 40px;">
          <div ref="data-security" class="data-security">
            <div class="title">数据安全</div>
            <div class="data-security-content">
              <div v-for="(item, index) in dataSecurityList" :key="index" class="data-security-list-item">
                <img :src="item.icon" alt="" class="list-item-icon" />
                <div class="list-item-title">
                  {{ item.title }}
                </div>
                <div class="data-security-text">
                  <div v-for="(textItem, textIndex) in item.textList" :key="textIndex" class="list-text-item">
                    <div class="text">{{ textItem }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="customer-stories">
          <div style="width: 100%; height: 60px; background-color: #f7f9fc;"></div>
          <div class="customer-stories">
            <div class="customer-stories-content">
              <div class="title">中大型企业的共同选择</div>
              <div class="customer-stories-list">
                <div v-for="(item, index) in enterpriseList" :key="index" class="cystiner-stirues-item">
                  <img :src="item" alt="" />
                </div>
              </div>
              <div class="customer-stories-btn" @click="moreEnterprise">
                <div class="btn-text">
                  查看更多案例
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="data-download" class="data-download">
          <div class="title">行业资料</div>
          <div class="data-download-content">
            <div v-for="(item, index) in dataDownloadList" :key="index" class="data-download-content-item">
              <div class="item-title-box">
                <div class="dataListTitle">{{ item.title }}</div>
                <div class="subTitle">{{ item.subtitle }}</div>
              </div>
              <ul class="data-list">
                <li
                  v-for="(dataItem, dataIndex) in item.dataList"
                  :key="dataIndex"
                  class="data-list-item"
                  @click="clickDate(dataItem, index)"
                >
                  <div class="data-list-left">
                    <div class="disc"></div>
                    <div class="data-title">
                      {{ dataItem.title }}
                    </div>
                  </div>
                </li>
              </ul>
              <div class="item-index">0{{ index+1 }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="appointment-demonstration">
        <div class="content-center">
          <div class="appointment-demonstration-text">
            <h4 class="appointment-demonstration-title">了解更多有关华跃产品与服务信息</h4>
            <h5 class="appointment-demonstration-subtitle">您还可以预约我们的产品演示</h5>
          </div>
          <div class="appointment-demonstration-btn" @click="openBealter">
            <span>预约产品显示</span>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail, download } from '@/api/content';
// import stories1 from '@/assets/staffmanage/stories1.png';
// import stories2 from '@/assets/staffmanage/stories2.png';
// import stories3 from '@/assets/staffmanage/stories3.png';
// import stories4 from '@/assets/staffmanage/stories4.png';
// import stories5 from '@/assets/staffmanage/stories5.png';
// import stories6 from '@/assets/staffmanage/stories6.png';
// import stories7 from '@/assets/staffmanage/stories7.png';
export default {
  name: 'PersonnelRecruit',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/personnelrecruit/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      valueIndex: null,
      topNaviId: null,
      navList: [
        {
          title: '产品价值',
          id: 'product-value',
        },
        {
          title: '系统架构',
          id: 'architecture',
        },
        {
          title: '功能介绍',
          id: 'introduction',
        },
        {
          title: '数据安全',
          id: 'data-security',
        },
        {
          title: '客户案例',
          id: 'customer-stories',
        },
        {
          title: '资料下载',
          id: 'data-download',
        },
      ],
      productValue: '',
      architecture: '',
      introductionTagList: [
        // {
        //   text: '岗位智配',
        //   index: 0,
        // },
        // {
        //   text: '一键发布',
        //   index: 1,
        // },
        // {
        //   text: '在线评价',
        //   index: 2,
        // },
        // {
        //   text: '人才分析',
        //   index: 3,
        // },
      ],
      introductionIndex: 0,
      introductionList: [
        // {
        //   title: '条件太多，如何快速筛选合适简历',
        //   img: require('@/assets/personnelrecruit/introduction1.png'),
        //   content: [
        //     '设置岗位智配规则，利用模糊比对的功能实现对简历匹配',
        //     '每条岗位要求设置权重比例，可以计算每份简历的匹配度',
        //     '根据匹配度的高低不同，形成对简历信息的等级管理',
        //   ],
        // },
        // {
        //   title: '合作渠道太多，重复登记岗位招聘要求',
        //   img: require('@/assets/personnelrecruit/introduction2.png'),
        //   content: [
        //     '建立招聘渠道管理，实现对多个渠道信息进行综合管理',
        //     '自动获取岗位招聘要求，一键填充网站信息',
        //     '多个网站实现自动识别，一键发布招聘信息',
        //   ],
        // },
        // {
        //   title: '在线评价',
        //   img: require('@/assets/personnelrecruit/introduction3.png'),
        //   content: [
        //     '各部门根据岗位需要设置自定义的评价方案',
        //     '使用移动端调取评价方案，对面试者进行各个维度的评分',
        //     '多轮面试后系统自动综合分析，将结果呈现给管理者',
        //   ],
        // },
        // {
        //   title: '人才分析',
        //   img: require('@/assets/personnelrecruit/introduction4.png'),
        //   content: [
        //     '获取各个环节节点数据，自动整合分析',
        //     '输出可视化的数据结果，直观体现招聘工作效能',
        //     '对渠道优劣进行分析，帮助企业更好的选择招聘渠道',
        //   ],
        // },
      ],
      dataDownloadList: [
        {
          title: '资料下载',
          subtitle: '行业资料下载',
          dataList: [
            {
              id: 1,
              title: '华跃科技2022年国庆节放假通知',
            },
            {
              id: 2,
              title: '华跃科技携手广东股权交易中心&链股科技，以薪酬与股权激励，激发企业人才动力',
            },
            {
              id: 3,
              title: '【喜报】热烈祝贺华跃科技签约中标广东高壹工机有限公司人力资源管理系统项目',
            },
            {
              id: 4,
              title: '【喜报】热烈祝贺华跃科技与顶财人力、方特咨询两家公司达成战略合作',
            },
          ],
        },
        {
          title: '产品动态',
          subtitle: '产品更新动态',
          dataList: [
            {
              id: 5,
              title: '华跃科技2022年国庆节放假通知',
            },
            {
              id: 6,
              title: '华跃科技携手广东股权交易中心&链股科技，以薪酬与股权激励，激发企业人才动力',
            },
            {
              id: 7,
              title: '【喜报】热烈祝贺华跃科技签约中标广东高壹工机有限公司人力资源管理系统项目',
            },
            {
              id: 8,
              title: '【喜报】热烈祝贺华跃科技与顶财人力、方特咨询两家公司达成战略合作',
            },
          ],
        },
        {
          title: '干货推荐',
          subtitle: '行业硬知识',
          dataList: [
            {
              id: 9,
              title: '华跃科技2022年国庆节放假通知',
            },
            {
              id: 10,
              title: '华跃科技携手广东股权交易中心&链股科技，以薪酬与股权激励，激发企业人才动力',
            },
            {
              id: 11,
              title: '【喜报】热烈祝贺华跃科技签约中标广东高壹工机有限公司人力资源管理系统项目',
            },
            {
              id: 12,
              title: '【喜报】热烈祝贺华跃科技与顶财人力、方特咨询两家公司达成战略合作',
            },
          ],
        },
      ],
      dataSecurityList: [
        // {
        //   icon: require('@/assets/staffmanage/data-security1.png'),
        //   title: '身份认证',
        //   textList: [
        //     '传统用户名/密码认证',
        //     '支持动态密码安全认证方式',
        //     '支持USBE-key电子密钥安全认证方式(CA)',
        //   ],
        // },
        // {
        //   icon: require('@/assets/staffmanage/data-security2.png'),
        //   title: '安全访问',
        //   textList: [
        //     '通过授权定义用户的数据范围',
        //     '可以单独或分段设置能够登陆系统的终端，限制未授权机器访问系统',
        //     '提供针对用户访问数据的操作监视和统计，根据用户身份和应用活动进行审计',
        //   ],
        // },
        // {
        //   icon: require('@/assets/staffmanage/data-security3.png'),
        //   title: '品质保证',
        //   textList: [
        //     '十五年专注经营',
        //     '3000+企业长期合作',
        //     '大型集团化企业的首选',
        //   ],
        // },
      ],
      enterpriseList: [
        // stories1,
        // stories2,
        // stories3,
        // stories4,
        // stories5,
        // stories6,
        // stories7,
        // stories1,
        // stories2,
        // stories3,
        // stories4,
        // stories5,
        // stories6,
        // stories7,
      ],
    };
  },
  watch: {
    scrollTop(newValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
    this.getPartner();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1605835552639377408', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '产品价值') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              this.productValue = rrsult.icon;
              // const doc = new DOMParser().parseFromString(rrs.result.elements[0].content, 'text/html');
              // this.productValue = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
            });
          } else if (result[i].name === '系统架构') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              this.architecture = rrsult.icon;
            });
          } else if (result[i].name === '功能介绍') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            const rrs = await getContentList(data);
            const rrsult = rrs.result;
            for (var j = 0; j < rrsult.data.length; j++) {
              this.introductionTagList.push({
                text: rrsult.data[j].title,
                index: j,
              });
              const rts = await getContentDetail(rrsult.data[j].id);
              const rtsult = rts.result;
              // const doc = new DOMParser().parseFromString(rtsult.defaultContent, 'text/html');
              var introduction = {
                title: rtsult.description,
                img: rtsult.icon,
                content: [],
              };
              for (var x = 0; x < rtsult.elements.length; x++) {
                introduction.content.push(rtsult.elements[x].content);
              }
              this.introductionList.push(introduction);
            }
          } else if (result[i].name === '数据安全') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var dataSecurityItem = {
                  icon: rtsult.icon,
                  title: rtsult.title,
                  textList: [],
                };
                for (var x = 0; x < rtsult.elements.length; x++) {
                  dataSecurityItem.textList.push(rtsult.elements[x].content);
                }
                this.dataSecurityList.push(dataSecurityItem);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
      const downLoadParams = { columnId: '1605494229646401536', pageNum: 1, pageSize: 4, commendation: 12, cascade: true, };
      getContentList(downLoadParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[0].dataList = result.data;
      });
      const contentParams = { columnId: '1605774350588534784', pageNum: 1, pageSize: 4, commendation: 12, };
      getContentList(contentParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[1].dataList = result.data;
      });
      const industryParams = { columnId: '1605774444985540608', pageNum: 1, pageSize: 4, commendation: 12, };
      getContentList(industryParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[2].dataList = result.data;
      });
    },

    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 18, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.enterpriseList.push(result.data[i].logo);
        }
      });
    },

    clickDate(data, index) {
      if (index === 0) {
        getContentDetail(data.id).then((res) => {
          const { result, } = res;
          var file = result.elements.find(obj => obj.name === 'file').content;
          download(file[0].url).then((rrs) => {
            const fileName = file[0].name;
            const blob = new Blob([ rrs.data, ]);
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(fileName));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a');
              tempLink.style.display = 'block';
              tempLink.href = blobURL;
              tempLink.setAttribute('download', decodeURI(fileName));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
            }
          });
        });
      } else if (index === 1) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 1, }, });
      } else if (index === 2) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 2, }, });
      }
    },

    changeStep(i) {
      this.introductionIndex = i.index;
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.personnel-recruit{
  background-color: #fff;
  .page-content{
    width: 100%;
    .personnel-recruit-canvas{
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .personnel-recruit-background{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        //  width: 100%;
        // height: 560px;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // object-fit: cover;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
          width: 85%;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          .solution-info {
            width: 540px;
            height: 560px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            .solution-info-title {
              font-size: 45px;
              font-weight: bold;
              line-height: 55px;
              color: #181818;
              margin-bottom: 30px;
            }
            .solution-info-content {
              font-size: 20px;
              line-height: 32px;
              color: #7b7b7b;
              margin-bottom: 44px;
            }
            .solution-btn {
              width: 142px;
              height: 48px;
              background-color: #00b0dc;
              color: #fff;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
              border-radius: 24px;
            }
          }
        }
    }
    .personnel-grow-nav{
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .personnel-grow-nav-tabs{
        margin: 0 auto;
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        top: -26px;
        .personnel-grow-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .personnel-grow-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #ffffff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .product-value{
      width: 1200px;
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .flow-chart-content{
        width: 100%;
        img{
          display: block;
          width: 100%;
        }
      }
    }
    .architecture{
      width: 1200px;
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .flow-chart-content{
        width: 100%;
        img{
          display: block;
          width: 100%;
        }
      }
    }
    .introduction{
      width: 100%;
      padding-top: 109px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        padding-bottom: 70px;
        box-sizing: border-box;
      }
      .introduction-tag-list{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        .tag-list-item{
          flex: 1;
          display: flex;
          justify-content: center;
          .tag-list-text{
            font-size: 20px;
            color: #181818;
            line-height: 63px;
            cursor: pointer;
            border-bottom: 6px solid transparent;
          }
          .tag-list-text:hover{
            font-weight: 600;
            border-bottom: 6px solid #00b0dc;
          }
        }
        .tag-list-item-change{
          .tag-list-text{
            font-weight: 600;
            border-bottom: 6px solid #00b0dc;
          }
        }
      }
      .introduction-content-box{
        width: 100%;
        background-color: #f8fbff;
        padding: 80px 0 60px;
        .introduction-content{
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .introduction-content-left{
            width: 420px;
            padding-top: 80px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            .content-title{
              width: 100%;
              font-size: 28px;
              font-weight: 600;
              color: #181818;
              margin-bottom: 30px;
            }
            .content-text-box{
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              margin-bottom: 11px;
              .content-text-li{
                width: 6px;
                height: 6px;
                background-color: #c8defe;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 9px;
              }
              .content-text{
                font-size: 16px;
                color: #314666;
              }
            }
          }
          .introduction-content-right{
            width: 740px;
            height: 460px;
            img{
              width: 100%;
              height: auto;
              display: block;
            }
          }
        }
      }
    }
    .data-download{
      width: 1200px;
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 100px;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-download-content{
        display: flex;
        margin: 70px auto 0;
        .data-download-content-item{
          width: 380px;
          height: 375px;
          margin-right: 30px;
          box-sizing: border-box;
          position: relative;
          border: 1px solid #dfdfdf;
          background-color: #fff;
          border-radius: 8px;
          position: relative;
          .item-title-box{
            width: 100%;
            height: 80px;
            background-image: linear-gradient(78deg,
                #edf3f9 0%,
                #ffffff 100%);
            position: relative;
            padding: 44px 0px 0px 36px;
            box-sizing: border-box;
            .dataListTitle{
              position: absolute;
              top: 0;
              left: 0;
              width: 91px;
              height: 33px;
              font-size: 14px;
              color: #fff;
              line-height: 1;
              background: url('@/assets/personnelrecruit/icon/data-background.png') no-repeat;
              line-height: 28px;
              padding-left: 10px;
            }
            .subTitle{
              line-height: 1;
              font-size: 16px;
              font-weight: 600;
              color: #181818;
            }
          }
          .data-list{
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            .data-list-item{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 19px;
              // padding-left: 24px;
              box-sizing: border-box;
              list-style:disc;
              .data-list-left{
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .disc{
                  width: 2px;
                  height: 2px;
                  background-color: #6d717c;
                }
                .data-title{
                  flex: 1;
                  font-size: 14px;
                  color: #6d717c;
                  cursor: pointer;
                  position: relative;
                  margin-left: 15px;
                }
              }
            }
            .data-list-item:hover{
              .data-list-left{
                .disc{
                  background-color: #00b0dc;
                }
                .data-title{
                  color: #00b0dc;
                }
              }
              .data-list-right{
                display: block;
              }
            }
          }
          .item-index{
            position: absolute;
            bottom: 20px;
            right: 27px;
            font-size: 56px;
            color: #f1f6fa;
            font-family: HelveticaNeueDeskInterface-Heavy;
          }
        }
        .data-download-content-item:last-child{
          margin-right: 0;
        }
      }
    }
    .data-security{
      width: 1200px;
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-security-content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 70px;
        .data-security-list-item{
          width: 380px;
          height: 448px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background-color: #fff;
          border-radius: 12px;
          .list-item-icon{
            width: auto;
            height: 117px;
            margin-bottom: 7px;
          }
          .list-item-title{
            font-size: 18px;
            color: #181818;
            font-weight: 500;
            margin-bottom: 35px;
          }
          .data-security-text{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .list-text-item{
              width: 290px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-bottom: 24px;
              .text{
                width: 100%;
                font-size: 15px;
                color: #6d717c;
                text-align: center;
              }
            }
          }
        }
      }
    }
    .customer-stories{
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      background: url('@/assets/staffmanage/customer-back.png') no-repeat;
      background-position: center;
      background-size: cover;
      background-position: center;
      height: 561px;
      padding: 69px 0 60px;
      box-sizing: border-box;
      .customer-stories-content{
        width: 80%;
        min-width: var(--minwidth);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-weight: 500;
          color: #181818;
          margin-bottom: 70px;
        }
        .customer-stories-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .cystiner-stirues-item{
            width: calc(16.666% - 20px);
            height: 70px;
            margin: 10px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;
            padding: 10px;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
        }
        .customer-stories-btn{
          width: 155px;
          height: 50px;
          background-color: #00b0dc;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          .btn-text{
            font-size: 15px;
            color: #ffffff;
          }
          &:hover{
            transform: scale(1.1);
            transition: all  0.5s;
          }
        }
      }
    }
    .appointment-demonstration{
      width: 100%;
      height: 126px;
      background-image: url('@/assets/personnelgrow/appointment-demonstration.png');
      background-repeat: no-repeat;
      background-size: cover;
      color: #fff;
      // padding: 22px;
      box-sizing: border-box;
      .content-center{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .appointment-demonstration-text{
          .appointment-demonstration-title{
            font-size: 22px;
            color: #fff;
            font-weight: 500;
            margin-bottom: 16px;
            line-height: 1;
          }
          .appointment-demonstration-subtitle{
            font-size: 16px;
            font-weight: 400;
            color: #fff;
            line-height: 1;
          }
        }
        .appointment-demonstration-btn{
          width: 124px;
          height: 42px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 8px;
          border: 1px solid #fff;
          line-height: 42px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 400;
          // img{
          //   width: 18px;
          //   height: 42px;
          //   vertical-align: middle;
          // }
          transition: all 0.5s;
          // &:hover{
          //   transform: scale(1.1);
          //   transition: all  0.5s;
          // }
        }
      }
    }
  }
}
</style>
